//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { axiosPost } from '../../axios/axios.js'
import AskImprovementPropsWindow from './AskImprovementPropsWindow.vue'
import ReportImprovementProposedEmployees from './ReportImprovementProposedEmployees.vue'

export default {
  components: {
    ReportImprovementProposedEmployees: ReportImprovementProposedEmployees,
    AskImprovementPropsWindow: AskImprovementPropsWindow
  },
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    taskStatus: {
      type: String,
      default () {
        return {}
      }
    },
    isAudit: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      reportManager: null,
      hasMultipleReport: false
    }
  },
  computed: {
    ...mapGetters({
      getCurrentDocumentValidationErrors: 'getCurrentDocumentValidationErrors'
    }),
    saveRemarksCondition: function () {
      return this.report.actionsAccess.saveRemarksCondition
    },
    improvementsCommonDisplayCondition: function () {
      return this.report.actionsAccess.improvementsCommonDisplayCondition
    },
    saveImprovementsCondition: function () {
      return this.report.actionsAccess.saveImprovementsCondition
    },
    saveInActiveStateCondition: function () {
      return this.report.actionsAccess.saveInActiveStateCondition
    },
    displaySaveChangesButton: function () {
      return this.report.actionsAccess.displaySaveChangesButton
    },
    disabledSaveChangesButton: function () {
      return this.getCurrentDocumentValidationErrors > 0
    },

    saveAccess: function () {
      return this.report.actionsAccess.saveAccess
    },

    PR3_displayReadyToCheckButton: function () {
      return this.report.actionsAccess.PR3_displayReadyToCheckButton
    },
    PR4_displayAcceptButton: function () {
      return this.report.actionsAccess.PR4_displayAcceptButton
    },
    PR7_displayVerifiedNoCommentsButton: function () {
      return this.report.actionsAccess.PR7_displayVerifiedNoCommentsButton
    },
    PR8_displayVerifiedHaveCommentsButton: function () {
      return this.report.actionsAccess.PR8_displayVerifiedHaveCommentsButton
    },
    getVerifiedHaveCommentsButtonText: function () {
      if (this.report.actionsAccess.reworkReportByExecutor && !this.report.actionsAccess.reworkReportAssignment) {
        return 'Доработать'
      }
      return 'Отправить на доработку'
    },
    PR9_displayFixingProblemsButton: function () {
      return this.report.actionsAccess.PR9_displayFixingProblemsButton
    },
    PR9_displayFixingProblemsWithReadyToRecheckButton: function () {
      return this.report.actionsAccess.PR9_displayFixingProblemsWithReadyToRecheckButton
    },
    PR10_displayReadyToRecheckButton: function () {
      return this.report.actionsAccess.PR10_displayReadyToRecheckButton
    },

    displayChangeExecutorOfImprovementsButton: function () {
      return this.report.actionsAccess.changeExecutorOfImprovements
    },
    displaySetCheckedByDispatcherButton: function () {
      return this.report.actionsAccess.setCheckedByDispatcher
    }
  },
  watch: {
    report: {
      handler: function (report) {
        if (!this.reportManager) {
          this.reportManager = report._reportManager
        }
        this.reportManager.validator = this.$parent // TODO report validation
      },
      immediate: true
    }
  },
  created: function () {
    if (this.$route.query.multiple === 'false') {
      this.hasMultipleReport = true
    } else {
      this.hasMultipleReport = false
    }
  },
  methods: {
    PR3_ReadyToCheck: function () {
      this.$d_ask({
        callback: () => {
          this.changePBState('PR3', null, 'Ошибка отправки отчёта на проверку', true)
        },
        header: 'Отправить отчёт на проверку?'
      })
    },
    PR4_Accept: function () {
      this.$d_ask({
        callback: () => {
          this.changePBState('PR4', null, 'Ошибка принятия работ', true)
        },
        header: 'Прнять работы?'
      })
    },
    PR7_VerifiedNoComments: function () {
      if (this.$parent.validate('PR7')) {
        this.changePBState('PR7', null, 'Ошибка утверждения отчёта', true) // TODO save - action
      }
    },
    PR8_VerifiedHaveComments: function () {
      this.$refs.askImprovementCommentWindow.ask((data) => {
        if (this.report.actionsAccess.reworkReportAssignment && data.improvementsExecutor) {
          const employee = this.$store.getters.getUser.employee
          if (employee && typeof data.improvementsExecutor !== 'number' && data.improvementsExecutor[employee.id] == null) {
            data.improvementsExecutor[employee.id] = true
          }
        }
        this.changePBState('PR8', data, 'Ошибка отправки отчёта в доработку', !this.report.actionsAccess.reworkReportByExecutor && !this.report.actionsAccess.reworkReportAssignment) // TODO save - action
      }, 'Отправка отчёта на доработку')
    },
    PR9_FixingProblemsWithAsk: function (readyToRecheck = false) {
      if ((this.reportRoles.roleReportCheckerOrHigher || this.reportRoles.roleDispatcherOrHigher) || (this.report.stateId === 'PR8' && !readyToRecheck)) {
        this.PR9_FixingProblems(readyToRecheck)
      } else {
        const message = this.report.stateId === 'PR8' ? (readyToRecheck ? 'Отправить отчёт на проверку?' : 'Доработать отчёт?') : 'Вернуться к доработке отчёта?'
        this.$d_ask({
          callback: () => {
            this.PR9_FixingProblems(readyToRecheck)
          },
          header: message
        })
      }
    },
    PR9_FixingProblems: async function (readyToRecheck = false) {
      const additionalProperties = { readyToRecheck: readyToRecheck }
      if (this.report.stateId === 'PR8') {
        this.trySaveChanges(additionalProperties, true) // TODO save - action
      } else {
        this.changePBState('PR9', additionalProperties, 'Ошибка перевода отчёта в доработку', false)
      }
    },
    PR10_ReadyToRecheckWithAsk: function (approve = false) {
      if (this.reportRoles.roleReportCheckerOrHigher || this.reportRoles.roleDispatcherOrHigher) {
        this.PR10_ReadyToRecheck()
      } else {
        const message = approve ? 'Утвердить отчёт?' : 'Отправить отчёт на проверку?'
        this.$d_ask({
          callback: () => {
            this.PR10_ReadyToRecheck(approve)
          },
          header: message
        })
      }
    },
    PR10_ReadyToRecheck: function (approve = false) {
      this.changePBState('PR10', { approve: approve }, 'Готовность к проверке отчёта', true) // TODO save - action
    },
    changeExecutorOfImprovements: function () {
      this.$refs.executorSelector.select(() => this.$emit('report-updated'), true)
    },
    setCheckedByDispatcher: async function () {
      this.$q.loading.show({ spinnerColor: 'blue-11' })
      await axiosPost({
        url: '/service/delta/report/setChecked?reportId=' + this.report.id,
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Отчёт отмечен как проверенный',
            progress: true,
            timeout: 3000
          })

          this.$emit('report-updated')
        },
        onFailure: 'Не удалось отметить отчёт как проверенный',
        msgTarget: this
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    trySaveChanges: async function (additionalProperties, force) { // TODO save - action
      if (!this.reportManager.validate(this)) {
        return
      }

      this.$q.loading.show({ spinnerColor: 'blue-11' })
      this.$emit('save-changes-started')
      let isChanged = false
      // let hasErrors = false
      try {
        isChanged = await this.reportManager.saveChanges({ additionalProperties, ignoreValidation: true, force, target: this })
        if (!isChanged) {
          this.$q.notify({
            type: 'warning',
            message: 'Нет изменений',
            progress: true,
            timeout: 8000
          })
        }
      } catch (ignored) {
        // hasErrors = true
      } finally {
        this.$q.loading.hide()
        if (isChanged) {
          this.$emit('report-updated')
        }
      }
    },
    changePBState: async function (state, props, errMsg, saveChanges = true) {
      this.$q.loading.show({ spinnerColor: 'blue-11' })
      let isChanged = false

      if (saveChanges) {
        try {
          isChanged = await this.reportManager.saveChanges({ target: this })
        } catch (error) {
          this.$q.loading.hide()
          return
        }
      }

      const businessProcess = state.startsWith('BS') ? 'requestBusinessProcess' : 'requestReport'
      const objectId = state.startsWith('BS') ? this.report.bpContextId : this.report.id
      const bodyFormData = new FormData()
      bodyFormData.set('objectId', objectId)

      if (props != null) {
        bodyFormData.set('props', JSON.stringify(props))
      }

      const bpChangeResult = {
        businessProcess,
        objectId,
        props,
        // ===
        reportChanged: isChanged,
        result: null,
        status: null
      }

      axiosPost({
        url: '/service/delta/' + businessProcess + '/' + state,
        data: bodyFormData,
        onSuccess: response => {
          this.$q.notify({
            type: 'positive',
            message: 'Успешное изменения статуса задания',
            progress: true,
            timeout: 3000
          })

          bpChangeResult.reportChanged = true // TODO по ответу сервера
          bpChangeResult.result = response.data && response.data.result || null
          bpChangeResult.status = response.data && response.data.status || null

          this.$emit('report-updated', bpChangeResult) // refactor
          this.$q.loading.hide()
        },
        onFailure: (response) => {
          errMsg = response.message || errMsg
          this.$q.notify({
            type: 'negative',
            message: errMsg,
            progress: true,
            timeout: 8000
          })

          if (isChanged) {
            bpChangeResult.status = 'error'
            this.$emit('report-updated', bpChangeResult)
          }

          this.$q.loading.hide()
        }
      })
    }
  }
}

